const rewardFormatter = (value: number | string | undefined): string =>
  value ? `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
export { rewardFormatter };
